// X account type (Personal / Creator / Business) as a small badge or a label.
// Reported account classification does not grant private analytics through the browser adapter.

import type { IgAccountType } from "@gmx/shared";
import { Badge } from "@gmx/ui";
import { Briefcase, Sparkles, User } from "lucide-react";

export const ACCOUNT_TYPE_LABELS: Record<IgAccountType, string> = {
  personal: "Personal",
  creator: "Creator",
  business: "Business",
};

export function accountTypeLabel(t: IgAccountType | null | undefined): string {
  return ACCOUNT_TYPE_LABELS[t ?? "personal"] ?? "Personal";
}

export function AccountTypeBadge({ type, size = "sm" }: { type: IgAccountType | null | undefined; size?: "sm" | "md" }) {
  const t = type ?? "personal";
  const icon = t === "business" ? <Briefcase size={11} /> : t === "creator" ? <Sparkles size={11} /> : <User size={11} />;
  return (
    <Badge
      size={size}
      tone={t === "personal" ? "neutral" : "info"}
      icon={icon}
      title={`${ACCOUNT_TYPE_LABELS[t]} account — private analytics are unavailable through this browser connection`}
    >
      {ACCOUNT_TYPE_LABELS[t]}
    </Badge>
  );
}
